import { configContext } from '@bymason/runtime-config';
import { ApiBase } from '@bymason/api-base';
import { SubscriptionModel } from './types';
import { getData } from './stub-data';

export * from './types';

class Subscription extends ApiBase {
  private static instance: Subscription;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A Subscription instance
   */
  public static getInstance(): Subscription {
    if (!Subscription.instance) {
      Subscription.instance = new Subscription();
    }

    return Subscription.instance;
  }

  /**
   * Gets a user's subscription.
   * @param clientToken token required for proper authorization.
   * @returns either a subscription model or void
   */
  public async getSubscription(clientToken: string) {
    if (configContext === 'local') {
      // client is running local in dev-mode, so return stubbed data
      console.log('getSubscription() is running locally, so returning stubbed data');
      return getData();
    }

    const url = this.getEndpointTemplate('data/subscription');

    const dataResponse = await this.callJsonEndpoint<SubscriptionModel>({
      clientToken,
      errorOn404: false,
      method: 'GET',
      url,
      useSessionCache: true,
    });

    return dataResponse;
  }
}

export const subscriptionClient = Subscription.getInstance();
